import { Typography } from "@/components/typography";
import { ErrorMessage, Field } from "formik";
import { FC } from "react";

interface props {
  sx?: string;
  title?: string;
  name: string;
  placeholder?: string;
  optional?: boolean;
  type?: "text" | "email";
  disabled?: boolean;
}

const FormInput: FC<props> = ({
  title,
  sx,
  name,
  placeholder,
  optional,
  type = "text",
  disabled,
}) => (
  <div className={sx}>
    {title ? (
      <label htmlFor={name} className="flex items-center gap-1">
        <Typography tag="p" className="my-2 text-sm font-[400] tracking-wide">
          {title}{" "}
          {!optional && (
            <Typography tag="span" className="text-red">
              *
            </Typography>
          )}{" "}
        </Typography>{" "}
      </label>
    ) : null}
    <Field
      id={name}
      name={name}
      placeholder={placeholder}
      type={type}
      autoComplete="off"
      disabled={disabled}
      className="border px-3 py-3 rounded-md outline-[0.1px] outline-[#83b6b9] w-full"
    />
    <ErrorMessage
      name={name}
      component="span"
      className="text-red text-sm my-1"
    />
  </div>
);

export default FormInput;
